import { render, staticRenderFns } from "./setting-resetPassword.vue?vue&type=template&id=15e08f5f&scoped=true&"
import script from "./setting-resetPassword.vue?vue&type=script&lang=js&"
export * from "./setting-resetPassword.vue?vue&type=script&lang=js&"
import style0 from "./setting-resetPassword.vue?vue&type=style&index=0&id=15e08f5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e08f5f",
  null
  
)

export default component.exports